import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const authenticate = async (path, body) => {
    const { data } = await api.post(path, body);
    localStorage.setItem("token", data.token);
    setUser(data.user);
  };

  const updateAccount = async (body) => {
    const { data } = await api.put("/auth/account", body);
    localStorage.setItem("token", data.token);
    setUser(data.user);
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("token");
    setUser(false);
  };

  const isAdmin = user?.role === "admin";
  const can = (perm) => isAdmin || !!user?.permissions?.includes(perm);

  return <AuthCtx.Provider value={{ user, authenticate, updateAccount, logout, isAdmin, can }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
